import { CONNECTION_CHANGE_HANDLED } from 'actions/types/utils';
import { SET_LINKING_CONNECTION } from 'actions/types/linkbank';
import { HIDE_SUCCESS, LOGGED_OUT } from 'actions/types';
import { CREDIT_SCORE_GET_REPORT_FAILURE, CREDIT_SCORE_GET_REPORT_REQUEST, CREDIT_SCORE_GET_REPORT_SUCCESS, CREDIT_SCORE_RESET_DATA, CREDIT_SCORE_SET_PENDING_CONNECTION_REFETCH, } from '../actions/types';
const initialState = {
    data: {},
    isFetching: false,
    prunedSuggestedBankIds: [],
    pendingConnectionRefetch: false,
};
const pruneSuggestedBank = (state, bankId) => {
    const prunedSuggestedBankIds = state.prunedSuggestedBankIds ?? [];
    const hasSuggestion = bankId != null &&
        !prunedSuggestedBankIds.includes(bankId) &&
        (state.data.suggestedConnections ?? []).some((suggestion) => suggestion.bankId === bankId);
    if (!hasSuggestion)
        return state;
    return {
        ...state,
        prunedSuggestedBankIds: [...prunedSuggestedBankIds, bankId],
        pendingConnectionRefetch: true,
    };
};
const creditReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGGED_OUT:
        case CREDIT_SCORE_RESET_DATA: {
            return initialState;
        }
        case CREDIT_SCORE_GET_REPORT_REQUEST: {
            return {
                ...state,
                isFetching: true,
            };
        }
        case SET_LINKING_CONNECTION: {
            return pruneSuggestedBank(state, action.payload.connection.bankId);
        }
        case CONNECTION_CHANGE_HANDLED: {
            return action.payload.status
                ? pruneSuggestedBank(state, action.payload.bankInfo?.id)
                : state;
        }
        case CREDIT_SCORE_SET_PENDING_CONNECTION_REFETCH: {
            return state.pendingConnectionRefetch
                ? state
                : { ...state, pendingConnectionRefetch: true };
        }
        case CREDIT_SCORE_GET_REPORT_SUCCESS: {
            const { reportDate, personalInformation, searches, judgments, insolvencies, electoralRoll, addressLinks, financialConnections, otherNames, cifasCases, suggestedConnections, } = action.payload;
            const { accounts } = action.payload;
            return {
                ...state,
                isFetching: false,
                ...(action.extra?.isConnectionReconcile
                    ? { prunedSuggestedBankIds: [], pendingConnectionRefetch: false }
                    : {}),
                data: {
                    ...(reportDate ? { reportDate } : {}),
                    ...(personalInformation ? { personalInformation } : {}),
                    ...(accounts && accounts.length > 0 ? { accounts } : {}),
                    ...(searches ? { searches } : {}),
                    ...(judgments && judgments.length > 0 ? { judgments } : {}),
                    ...(insolvencies && insolvencies.length > 0 ? { insolvencies } : {}),
                    ...(electoralRoll ? { electoralRoll } : {}),
                    ...(addressLinks && addressLinks.length > 0 ? { addressLinks } : {}),
                    ...(financialConnections && financialConnections.length > 0
                        ? { financialConnections }
                        : {}),
                    ...(otherNames && otherNames.length > 0 ? { otherNames } : {}),
                    ...(cifasCases && cifasCases.length > 0 ? { cifasCases } : {}),
                    ...(suggestedConnections && suggestedConnections.length > 0
                        ? { suggestedConnections }
                        : {}),
                },
            };
        }
        case HIDE_SUCCESS: {
            const { accounts } = state.data;
            if (!accounts)
                return state;
            const hiddenById = new Map(action.extra.map(({ id, isHidden }) => [id, isHidden]));
            let didChange = false;
            const nextAccounts = accounts.map((account) => {
                const isHidden = account.networthAccountId != null
                    ? hiddenById.get(account.networthAccountId)
                    : undefined;
                if (isHidden === undefined)
                    return account;
                didChange = true;
                return { ...account, isTrackedInNetworth: !isHidden };
            });
            if (!didChange)
                return state;
            return { ...state, data: { ...state.data, accounts: nextAccounts } };
        }
        case CREDIT_SCORE_GET_REPORT_FAILURE: {
            return {
                ...state,
                isFetching: false,
            };
        }
        default:
            return state;
    }
};
export default creditReportReducer;
